// extracted by mini-css-extract-plugin
export default {"root":"MaintenanceMode_root__XHuot","header":"MaintenanceMode_header__Zeq8o","content":"MaintenanceMode_content__Vxx-W"};